import Alergens from './Alergens';
export default Alergens;
